module.exports = __webpack_public_path__ + "img/hifi.38ba94e5.png";